import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MinimumSubscriptionPlanRequiredDirective } from '../../shared/directives/MinimumSubscriptionRequired/minimum-subscription-required.directive';
import { AccessLevelRequiredDirective } from '../../shared/directives/access-level-required.directive';
import { HasPermissionDirective } from '../directives/has-permission.directive';
import { HasWidgetPermissionDirective } from '../directives/has-widget-permission.directive';
import { RowDeleteButtonDirective } from '../directives/listing/row/delete-button.directive';
import { ListRowDirective } from '../directives/listing/row.directive';
import { EchartsDirective } from '../directives/echarts.directive';
import {
  AsyncLoadedContentComponentDirective,
  BoxDirective,
  DialogButtonsTemplateDirective,
  DialogContenTemplatetDirective,
  DialogHeaderTitleTemplateDirective,
  GridColumnDirective,
  GridRowDirective,
  PaginationListItemDirective,
  TabPaneDirective,
  WYSWYGFormatDirective,
  DropdownButtonActionItemDirective,
  DropdownOptionGroupTemplateDirective,
  PaginationLinksTopContentDirective,
  TableRowColumnDirective,
  TableRowDirective,
  PageLayoutButtonsTemplateDirective,
  PageLayoutContentTemplateDirective,
  CardHeaderContentTemplateDirective,
  PageLayoutTitleTemplateDirective
} from '../directives/component.directive';
import { IsConfiguredDirective } from '../directives/is-configured.directive';
import { DisableScrollDirective } from '../directives/disable-scroll.directive';

@NgModule({
  declarations: [
    MinimumSubscriptionPlanRequiredDirective,
    AccessLevelRequiredDirective,
    HasPermissionDirective,
    HasWidgetPermissionDirective,
    RowDeleteButtonDirective,
    ListRowDirective,
    EchartsDirective,
    TabPaneDirective,
    GridColumnDirective,
    BoxDirective,
    GridRowDirective,
    AsyncLoadedContentComponentDirective,
    DialogHeaderTitleTemplateDirective,
    DialogButtonsTemplateDirective,
    DialogContenTemplatetDirective,
    PaginationListItemDirective,
    DropdownButtonActionItemDirective,
    IsConfiguredDirective,
    GridRowDirective,
    DialogHeaderTitleTemplateDirective,
    DialogButtonsTemplateDirective,
    DialogContenTemplatetDirective,
    WYSWYGFormatDirective,
    DropdownOptionGroupTemplateDirective,
    DisableScrollDirective,
    TableRowDirective,
    TableRowColumnDirective,
    PaginationLinksTopContentDirective,
    PageLayoutButtonsTemplateDirective,
    PageLayoutContentTemplateDirective,
    CardHeaderContentTemplateDirective,
    PageLayoutTitleTemplateDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MinimumSubscriptionPlanRequiredDirective,
    AccessLevelRequiredDirective,
    HasPermissionDirective,
    HasWidgetPermissionDirective,
    RowDeleteButtonDirective,
    ListRowDirective,
    EchartsDirective,
    TabPaneDirective,
    GridColumnDirective,
    BoxDirective,
    GridRowDirective,
    AsyncLoadedContentComponentDirective,
    DialogHeaderTitleTemplateDirective,
    DialogButtonsTemplateDirective,
    DialogContenTemplatetDirective,
    PaginationListItemDirective,
    DropdownButtonActionItemDirective,
    IsConfiguredDirective,
    GridRowDirective,
    DialogHeaderTitleTemplateDirective,
    DialogButtonsTemplateDirective,
    DialogContenTemplatetDirective,
    WYSWYGFormatDirective,
    DropdownOptionGroupTemplateDirective,
    DisableScrollDirective,
    TableRowDirective,
    TableRowColumnDirective,
    PaginationLinksTopContentDirective,
    PageLayoutButtonsTemplateDirective,
    PageLayoutContentTemplateDirective,
    CardHeaderContentTemplateDirective,
    PageLayoutTitleTemplateDirective,
  ],
})
export class DirectivesModule { }
